import { render, staticRenderFns } from "./licen.vue?vue&type=template&id=add39af4&scoped=true"
import script from "./licen.vue?vue&type=script&lang=js"
export * from "./licen.vue?vue&type=script&lang=js"
import style0 from "./licen.vue?vue&type=style&index=0&id=add39af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add39af4",
  null
  
)

export default component.exports